<script setup lang="ts">
import type { ICard } from '~/components/entity/card'
import { LucideCheck } from 'lucide-vue-next'

const { card } = defineProps<{ card: ICard }>()
const emit = defineEmits<{
  (e: 'options-status-change', status: boolean): void
}>()
const { t } = useI18n()

const relevantOptions = [
  { name: 'option_loyalty_program', text: t('entity.card.item.options.option_loyalty_program') },
  { name: 'option_bonuses', text: t('entity.card.item.options.option_bonuses') },
  { name: 'option_cashback', text: t('entity.card.item.options.option_cashback') },
  { name: 'option_online_payments', text: t('entity.card.item.options.option_online_payments') },
  {
    name: 'option_wireless_payments',
    text: t('entity.card.item.options.option_wireless_payments')
  },
  {
    name: 'option_sms_notifications',
    text: t('entity.card.item.options.option_sms_notifications')
  },
  { name: 'option_salary_project', text: t('entity.card.item.options.option_salary_project') },
  { name: 'option_online_banking', text: t('entity.card.item.options.option_online_banking') },
  { name: 'option_overdraft', text: t('entity.card.item.options.option_overdraft') }
] as const

const activeOptions = relevantOptions.filter((opt) => card[opt.name])

emit('options-status-change', activeOptions.length > 0)
</script>

<template>
  <div class="grid grid-cols-1 gap-2 md:grid-cols-2">
    <div v-for="item in activeOptions" :key="item.name" class="flex gap-2">
      <LucideCheck class="min-w-5 text-blue-600" />
      <p>{{ item.text }}</p>
    </div>
  </div>
</template>
